
const CARRY = [
    {
      page: 2,
      lib: "Carry",
      texteIndice: [
        "Au mur",
        "Donne l'heure",
        "Chiffre en double",
        "Le SIX"]
    },
    {
      page: 3,
      lib: "La seconde énigme",
      texteIndice: [
        "C'est un NARVAL",
        "L'AILE de la pie",
        "Réponse: VILLA ARENA"
      ]
    },
    {
      page: 6,
      lib: "Pétanque",
      texteIndice: [
        "En l'état, pas de solution possible",
        "Heureusement les boules ça roule",
        "Le 9 est un 6",
        "6 + 11 + 13 (Réponse : écu)"
      ]
    },
    {
      page: 8,
      lib: "L'olivier",
      texteIndice: [
        "Proche voie ferrée, trouvez le petit olivier",
        "Pierre peinte sous ses branches",
        "Réponse: Pétanque (Paix + Tank)"
      ]
    },
    {
      page: 9,
      lib: "Le pont",
      texteIndice: [
        "Pas en bois",
        "On y voie le 'fruit' de cet arbre",
        "Réponse : P (le PIN)"
      ]
    },
    {
      page: 10,
      lib: "Le centre",
      texteIndice: [
        "Les gendarmes sont sur un panneau",
        "PTT signifie 'Postes, télégraphes et téléphones' (surtout télégraphe !)",
        "Réponse: CORSE"
      ]
    },
    {
      page: 13,
      lib: "Sport",
      texteIndice: [
        "Superposez",
        "Sur le panneau de la même couleur",
        "Réponse: ABANDONNEZ"
      ]
    },
    {
      page: 14,
      lib: "Suite",
      texteIndice: [
        "Des croix par là où vous êtes passés",
        "Gardez les lettres de couleurs des croix",
        "Algue"
      ]
    },
    {
      page: 15,
      lib: "Voyage dans le temps",
      texteIndice: [
        "Revenez en arrière, mais pas vraiment",
        "Les symboles sont dans les pages précédentes",
        "Réponse: Père"
      ]
    },
    {
      page: 18,
      lib: "Liaisons",
      texteIndice: [
        "Sur la plaque retrouvez les mots",
        "Dessinez avec ces mots",
        "Les relier forme un lettre",
        "Réponse : A"
      ]
    },
    {
      page: 20,
      lib: "Liasons 2, le retour",
      texteIndice: [
        "Trouvez les points communs",
        "Ce sont des paires",
        "Réponse : Acteur"
      ]
    },
    {
      page: 22,
      lib: "Le Signal",
      texteIndice: [
        "Les cotés les plus courts sont les plus lourds",
        "Réponse : L"
      ]
    },
    {
      page: 23,
      lib: "Les posidonies",
      texteIndice: [
        "Comparez",
        "avec les pots des oliviers devant l'Office",
        "Réponse : E"]
    },
    {
      page: 99,
      lib_page: "Dernière étape - Vérifier la réponse à toute l'enquête !",
      lib: "Vous avez terminé le parcours ? Bravo ! Alors où se trouve le trésor ?",
      lib_win_title: "Bravo ! Félicitations !",
      lib_win_texte: "Encore un grand merci d'avoir participé à l'un de nos jeux !",
      questions: ["1ère moitié de la réponse", "2ème moitié de la réponse"],
      answers: [
        ["Le", "La chaine", "Le chemin", "Route", "Petit", "Grand"],
        ["Val-de-Ricard", "Romaron", "Abeilles", "Agrippa", "l'Estaque", "Sui"],
      ]
    }
  ];

export default CARRY;